import * as React from "react";
const DoubleTick = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5625 6.5625L4.6875 13.4375L1.25 10.0002"
      stroke="#23BD33"
      strokeWidth="1.5"
      stroke-linecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7518 6.5625L11.8768 13.4375L10.0508 11.6116"
      stroke="#23BD33"
      strokeWidth="1.5"
      stroke-linecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default DoubleTick;
